// extracted by mini-css-extract-plugin
module.exports = {"disableScroll":"Grid_disableScroll__ocHyY","hideInPercy":"Grid_hideInPercy__2a-16","item":"Grid_item__2-aWN","noPadding":"Grid_noPadding__15R52"};